import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IGameResponse, IGameWithParams, IVidParam } from './game.models';

import { convertObjectToRestapiParams } from 'src/app/utils/api.utils';

@Injectable()
export class GameService {
    private _http = inject(HttpClient);

    public getGameWithIdApi(
        gameId: string,
        params?: IGameWithParams
    ): Observable<IGameResponse> {
        return this._http.get<IGameResponse>(`games/${gameId}`, {
            params: convertObjectToRestapiParams(params)
        });
    }

    public getVidParamsForGameId(
        gameId: string
    ): Observable<IVidParam[]> {
        return this._http.get<IVidParam[]>(`games/${gameId}/vidparams`);
    }
}
